/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmOsobaCertifikat extends GContentBase<SeznamAdmOsobaCertifikatObj> {
        private seznamObj: SeznamAdmOsobaCertifikatObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmOsobaCertifikatObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmOsobaCertifikat",
                contentCaption: "jres:33000571", //RC 33000571 : Vlastní osobní certifikáty
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{jmeno_cer} - {nazev_ref}"
                },
                gridSettings: {
                    columnOrder: "jmeno_cer,nazev_ref,otisk_cer,email_cer,ulice_cer,obec_cer,firma_cer,utvar_cer,adresa_cer,dat_od_cer,dat_do_cer,id_cer,tel_cer,bio_cer,typ_cer_txt,alg_h_cer,jmeno_cau,ixs_cau,otisk_cau,priz_akr_cau,adresa_cau,ixs_ref,jmeno_ref,prijmeni_ref,login_name_ref,login_name2_ref,oc_ref,ixb,dat_od,dat_do,dat_zadost,zmenu_prov_zadost_txt,dat_schval,zmenu_prov_schval_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmOsobaCertifikatObj extends GAdmSeznamBase {
        ixs: string;
        private serviceCnt: GContent;

        private getServiceCnt(): GContent {
            if (this.serviceCnt == null || this.serviceCnt == undefined)
                this.serviceCnt = this.cnt.createServiceContent("Gordic.Adm.WebControls.SeznamAdmOsobaCertifikat");
            return this.serviceCnt;
        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailAdmOsobaCertifikat", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                data: data,
                dataListDescription: this.dataListDescription,
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailAdmOsobaCertifikat",
                newRecord: isNew,
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actCertifikatNew: {
                    caption: "jres:33000580",
                    icon: "gi-plus",
                    enabled: this.dataListDescription.data_right?.Write == true,
                    run: (ev, ctx) => {
                        this.createCertifikatNew();
                    }
                },
                actCertifikatSave: {
                    caption: "jres:32131041",
                    icon: "gi-save",
                    run: (ev, ctx) => {
                        this.createCertifikatSave(ev);
                    }
                },
                actCertifikatCancel: {
                    caption: "jres:32131042",
                    icon: "gi-window-close",
                    run: (ev, ctx) => {
                        $.content(ev.target).close();
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actCertifikatNew*", "actOpenDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:32131110").addField("gselectbox", Gordic.Prefabs.Select.ginsref(), {
                name: "ixs",
                model: "model.ixs=value.ixs_ref",
                dropdown: true,
                disabled: this.ixs ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs)
                hardFilter["ixs"] = this.ixs;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs)
                data["ixs"] = this.ixs;
        }

        applydata(filterData: any) {
            this.cnt.isl.AdmOsobaCertifikat.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#{2}#{3}#".format(data.ixs_cer, data.ixs, data.lic, data.por_zast),
                nazev: ""
            }
        }

        private createCertifikatNew() {
            var form = new Gordic.Forms.Form()
                .addRow("jres:32131110").addField("gselectbox", Gordic.Prefabs.Select.ginsref(), {
                    name: "ixs_ref",
                    model: "model.ixs_ref=value.ixs_ref",
                    initialValue: this.ixs ? { ixs_ref: this.ixs } : null,
                    disabled: this.ixs != null && this.ixs != undefined,
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    dropdown: true
                })
                .addRow("jres:30027574").addField("gfilefield", {
                    name: "certifikat",
                    maxFileCount: 1,
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required",
                    acceptExtension: ".cer"
                })
            this.cnt.dialogs.simpleForm("jres:33000580", form, null, { //RC 33000580 : Nový certifikát
                width: 600,
                height: 250,
                commandBar: [
                    { action: this.cnt.actions.actCertifikatSave, primary: true },
                    { action: this.cnt.actions.actCertifikatCancel }
                ]
            }) 
        }

        private createCertifikatSave(ev) {
            var cnt = $.content(ev.target);
            var saveObj: any = {};
            cnt.findFields().gfield("model", "collect", saveObj);
            this.getServiceCnt().call("SaveCertifikatNew", { guid: saveObj.certifikat[0].guid, ixs_ref: saveObj.ixs_ref }).done((result) => {
                cnt.close();
                this.updateDataInGrid(result.data.ixs_cer, saveObj.ixs_ref)
            })
        }

        private updateDataInGrid(ixs_cer: string, ixs: string) {
            this.cnt.isl.AdmOsobaCertifikat.list({
                filters: {
                    ixs_cer: ixs_cer,
                    ixs: ixs
                }
            }).getData().done((obj) => {
                if (this.filterData["aktivita"]) {
                    if (this.grid.length != 0) {
                        var gridView: Gordic.Data.View = this.grid.ggrid("getView");
                        if (Array.isArray(this.filterData["aktivita"])) {
                            if (obj[0].aktivita) {
                                if (this.filterData["aktivita"].findIndex(item => item == obj[0].aktivita) != -1)
                                    gridView.updateData(obj[0], "update")
                                else
                                    gridView.updateData(obj[0], "delete")
                            }
                        } else {
                            if (obj[0].aktivita == this.filterData["aktivita"])
                                gridView.updateData(obj[0], "update")
                            else
                                gridView.updateData(obj[0], "delete")
                        }
                        this.grid.ggrid("setData", gridView);
                        this.grid.ggrid("activeRow", obj[0]);
                    }
                    $.content().navigate(["Gordic.Adm.WebControls.DetailAdmOsobaCertifikat", {
                        currentFilter: this.filterData,
                        gridRc: new Gordic.Components.GridRC(this.grid),
                        data: obj[0],
                        dataListDescription: this.dataListDescription,
                    }], {
                        ID: "DetailAdmOsobaCertifikat",
                        newRecord: false,
                    })
                }
            })
        }
    }
}